import { Action } from '@ngrx/store';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';
import { ContractRestrictions } from '../contract-details/contract-details.interface';
import { Definition } from '../definitions/definition.interface';
import { Definitions } from '../definitions/definitions.interface';
import { SimplifiedEmailActor } from '../email-actors/email-actors.interface';
import { AvailablePickingDates, CalculatedTruckLoad, DeliveryMethod, FlorderDetailState, Material, OrderDetailTO } from '../edit-florder-detail/florder-detail.interface';
import { RecurrenceDates } from './order-detail.interface';

export const ORDERDETAIL_CLEAR = 'orderDetail:ORDERDETAIL_CLEAR';
export const ORDERDETAIL_OPEN = 'orderDetail:ORDERDETAIL_OPEN';
export const ORDERDETAIL_OPEN_SUCCESS = 'orderDetail:ORDERDETAIL_OPEN_SUCCESS';
export const ORDERDETAIL_OPEN_FAIL = 'orderDetail:ORDERDETAIL_OPEN_FAIL';
export const ORDERDETAIL_CREATE_START = 'orderDetail:ORDERDETAIL_CREATE_START'; // Start create-window
export const ORDERDETAIL_CREATE_SET_CUSTOMER = 'orderDetail:CREATE_STEP_0_SET_CUSTOMER';
export const ORDERDETAIL_CREATE_SET_DELIVERY_METHOD = 'orderDetail:CREATE_STEP_1_SET_DELIVERY_METHOD'; // Store deliveryMethod data in store, and go to details window in edit mode
export const ORDERDETAIL_CREATE_EDIT_ORDER_DETAIL = 'orderDetail:ORDERDETAIL_CREATE_EDIT_ORDER_DETAIL'; // Start adding a new material (used when editing details again)
export const ORDERDETAIL_CREATE_EDIT_ORDER_PLANNING = 'orderDetail:ORDERDETAIL_CREATE_EDIT_ORDER_PLANNING';
export const ORDERDETAIL_CREATE_EDIT_ORDER_PLANNING_GET_DATES_SUCCESS = 'orderDetail:ORDERDETAIL_CREATE_EDIT_ORDER_PLANNING_GET_DATES_SUCCESS';
export const ORDERDETAIL_CREATE_START_EDIT_MATERIAL = 'orderDetail:ORDERDETAIL_CREATE_START_EDIT_MATERIAL'; // Start editing an existing material
export const ORDERDETAIL_CREATE_SAVE_PLANNING = 'orderDetail:ORDERDETAIL_CREATE_SAVE_PLANNING';
export const ORDERDETAIL_CREATE_SAVE_MATERIAL_START = 'orderDetail:ORDERDETAIL_CREATE_SAVE_MATERIAL_START'; // Save material in store
export const ORDERDETAIL_CREATE_SAVE_MATERIAL_SUCCESS = 'orderDetail:ORDERDETAIL_CREATE_SAVE_MATERIAL_SUCCESS'; // Save material in store
export const ORDERDETAIL_CREATE_SAVE_MATERIAL_FAIL = 'orderDetail:ORDERDETAIL_CREATE_SAVE_MATERIAL_FAIL'; // Save material in store
export const ORDERDETAIL_CREATE_SAVE_MATERIAL_OVERLOAD = 'orderDetail:ORDERDETAIL_CREATE_SAVE_MATERIAL_OVERLOAD';
export const ORDERDETAIL_CREATE_DELETE_MATERIAL = 'orderDetail:ORDERDETAIL_CREATE_DELETE_MATERIAL'; // Delete material from store
export const ORDERDETAIL_CREATE_SAVE_ORDER_DETAIL = 'orderDetail:ORDERDETAIL_CREATE_SAVE_ORDER_DETAIL'; // Save order detail data in store
export const ORDERDETAIL_CREATE_SAVE_ORDER_DETAIL_GET_DATES_SUCCESS = 'orderDetail:ORDERDETAIL_CREATE_SAVE_ORDER_DETAIL_GET_DATES_SUCCESS'; // Save order detail data in store
export const ORDERDETAIL_CREATE_SUBMIT = 'orderDetail:ORDERDETAIL_CREATE_SUBMIT'; // Submit 'create order' data to middleware
export const ORDERDETAIL_CREATE_SUBMIT_FAIL = 'orderDetail:ORDERDETAIL_CREATE_SUBMIT_FAIL'; // Submit failed
export const ORDERDETAIL_CREATE_SUBMIT_SUCCESS = 'orderDetail:ORDERDETAIL_CREATE_SUBMIT_SUCCESS'; // Submit successful
export const ORDERDETAIL_CREATE_LOADINGDATES_SUCCESS = 'orderDetail:ORDERDETAIL_CREATE_LOADINGDATES_SUCCESS'; // get loading dates successful
export const ORDERDETAIL_LOAD_TRUCK_CALCULATE = 'orderDetail:ORDERDETAIL_LOAD_TRUCK_CALCULATE';
export const ORDERDETAIL_LOAD_TRUCK_CALCULATE_SUCCESS = 'orderDetail:ORDERDETAIL_LOAD_TRUCK_CALCULATE_SUCCESS';
export const ORDERDETAIL_LOAD_TRUCK_CALCULATE_FAIL = 'orderDetail:ORDERDETAIL_LOAD_TRUCK_CALCULATE_FAIL';
export const ORDERDETAIL_EDIT_CUSTOMER = 'orderDetail:ORDERDETAIL_EDIT_CUSTOMER';
export const ORDERDETAIL_EDIT_DELIVERY_METHOD = 'orderDetail:ORDERDETAIL_EDIT_DELIVERY_METHOD';
export const ORDERDETAIL_COPY_ORDER = 'orderDetail:ORDERDETAIL_COPY_ORDER'; // copy order
export const ORDERDETAIL_COPY_OPEN_ORDER_SUCCESS = 'orderDetail:ORDERDETAIL_COPY_OPEN_ORDER_SUCCESS'; // copy order open order success
export const ORDERDETAIL_COPY_OPEN_ORDER_NO_VALID_CONTRACT = 'orderDetail:ORDERDETAIL_COPY_OPEN_ORDER_NO_VALID_CONTRACT'; // copy order open order success
export const ORDERDETAIL_CREATE_FROM_TEMPLATE = 'orderDetail:ORDERDETAIL_CREATE_FROM_TEMPLATE'; // copy order
export const ORDERDETAIL_RESET_MATERIALS_AND_PLANNING = 'orderDetail:ORDERDETAIL_RESET_MATERIALS_AND_PLANNING';

export const ORDERDETAIL_REQUEST_DELIVERY_DATES = 'orderDetail:ORDERDETAIL_REQUEST_DELIVERY_DATES';
export const ORDERDETAIL_REQUEST_DELIVERY_DATES_SUCCESS = 'orderDetail:ORDERDETAIL_REQUEST_DELIVERY_DATE_SUCCESS';
export const ORDERDETAIL_REQUEST_DELIVERY_DATES_FAIL = 'orderDetail:ORDERDETAIL_REQUEST_DELIVERY_DATES_FAIL';

export const ORDERDETAIL_REQUEST_DELIVERY_DATES_NOEFFECT = 'orderDetail:ORDERDETAIL_REQUEST_DELIVERY_DATES_NOEFFECT';
export const ORDERDETAIL_REQUEST_DELIVERY_DATES_SUCCESS_NOEFFECT = 'orderDetail:ORDERDETAIL_REQUEST_DELIVERY_DATE_SUCCESS_NOEFFECT';
export const ORDERDETAIL_REQUEST_DELIVERY_DATES_FAIL_NOEFFECT = 'orderDetail:ORDERDETAIL_REQUEST_DELIVERY_DATES_FAIL_NOEFFECT';

export const ORDERDETAIL_BACK_TO_DELIVERY = 'orderDetail:ORDERDETAIL_BACK_TO_DELIVERY';
export const ORDERDETAIL_BACK_TO_DETAIL = 'orderDetail:ORDERDETAIL_BACK_TO_DETAIL';

export const ORDERDETAIL_DOCUMENT_DOWNLOAD = 'orderDetail:ORDERDETAIL_DOCUMENT_DOWNLOAD';
export const ORDERDETAIL_DOCUMENT_DOWNLOAD_FAIL = 'orderDetail:ORDERDETAIL_DOCUMENT_DOWNLOAD_FAIL';
export const ORDERDETAIL_DOCUMENT_DOWNLOAD_SUCCESS = 'orderDetail:ORDERDETAIL_DOCUMENT_DOWNLOAD_SUCCESS';

export const ORDERDETAIL_CCR_DOCUMENT_DOWNLOAD = 'orderDetail:ORDERDETAIL_CCR_DOCUMENT_DOWNLOAD';
export const ORDERDETAIL_CCR_DOCUMENT_DOWNLOAD_FAIL = 'orderDetail:ORDERDETAIL_CCR_DOCUMENT_DOWNLOAD_FAIL';
export const ORDERDETAIL_CCR_DOCUMENT_DOWNLOAD_SUCCESS = 'orderDetail:ORDERDETAIL_CCR_DOCUMENT_DOWNLOAD_SUCCESS';

export const ORDERDETAIL_GET_RECURRENCE_DATES_SUCCESS = 'orderDetail:ORDERDETAIL_GET_RECURRENCE_DATES_SUCCESS';
export const ORDERDETAIL_GET_RECURRENCE_DATES = 'orderDetail:ORDERDETAIL_GET_RECURRENCE_DATES';
export const ORDERDETAIL_GET_RECURRENCE_DATES_FAIL = 'orderDetail:ORDERDETAIL_GET_RECURRENCE_DATES_FAIL';

export const ORDERDETAIL_BACK_TO_CREATE_CONFIRM = 'orderDetail:ORDERDETAIL_BACK_TO_CREATE_CONFIRM';

export const ORDERDETAIL_BACK_TO_OVERVIEW = 'orderDetail:ORDERDETAIL_BACK_TO_OVERVIEW';

export const ORDERDETAIL_SET_ACTIVE_CUSTOMER = 'orderDetail:ORDERDETAIL_SET_ACTIVE_CUSTOMER';

export class OrderDetailBackToOverviewAction implements Action {
  readonly type = ORDERDETAIL_BACK_TO_OVERVIEW;
  logPayload = true;

  constructor(readonly payload: FlorderDetailState) {}
}

export class OrderCreateGetLoadingDatesAction implements Action {
  readonly type = ORDERDETAIL_CREATE_LOADINGDATES_SUCCESS;

  constructor(readonly payload: any) {}
}

export class OrderDetailClearAction implements Action {
  readonly type = ORDERDETAIL_CLEAR;
}

export class OrderDetailOpenAction implements Action {
  readonly type = ORDERDETAIL_OPEN;
  logPayload = true;

  ui = { id: ORDERDETAIL_OPEN, busy: true };

  constructor(readonly payload: { etmOrderNumber: string; salesOrderNumber: string; customerIds: string[] }) {}
}

export class OrderDetailOpenSuccessAction implements Action {
  readonly type = ORDERDETAIL_OPEN_SUCCESS;

  ui = { id: ORDERDETAIL_OPEN, busy: false };

  constructor(readonly payload: { definitions: Definitions; orderDetail: OrderDetailTO }) {}
}

export class OrderDetailOpenFailAction implements Action {
  readonly type = ORDERDETAIL_OPEN_FAIL;
  logPayload = true;

  ui = { id: ORDERDETAIL_OPEN, busy: false };

  constructor(readonly payload: any) {}
}

export class OrderDetailCreateStartAction implements Action {
  readonly type = ORDERDETAIL_CREATE_START;
  readonly module = 'order';
  logPayload = true;

  constructor(readonly payload: { selectedCustomer: Definition; date: string; restrictions: ContractRestrictions; preventCheckingContractDetails: boolean; isSuperUser: boolean }) {}
}

export class OrderDetailSetActiveCustomerAction implements Action {
  readonly type = ORDERDETAIL_SET_ACTIVE_CUSTOMER;
  readonly module = 'order';
  logPayload = true;

  constructor(readonly payload: { selectedCustomer: Definition; isSuperUser: boolean }) {}
}

export class OrderDetailCreateSetCustomerAction implements Action {
  readonly type = ORDERDETAIL_CREATE_SET_CUSTOMER;
  readonly module = 'order';
  logPayload = true;

  constructor(readonly payload: { customer: Customer }) {}
}

export class OrderDetailCreateSetDeliveryMethodAction implements Action {
  readonly type = ORDERDETAIL_CREATE_SET_DELIVERY_METHOD;
  readonly module = 'order';

  constructor(readonly payload: { deliveryMethod: DeliveryMethod; loadingDate: string }) {}
}

export class OrderDetailCreateEditOrderDetailAction implements Action {
  readonly type = ORDERDETAIL_CREATE_EDIT_ORDER_DETAIL;
}

export class OrderDetailCreateEditOrderPlanningAction implements Action {
  readonly type = ORDERDETAIL_CREATE_EDIT_ORDER_PLANNING;
}

export class OrderDetailCreateEditOrderPlanningGetDatesSuccessAction implements Action {
  readonly type = ORDERDETAIL_CREATE_EDIT_ORDER_PLANNING_GET_DATES_SUCCESS;
}

export class OrderDetailCreateStartEditMaterialAction implements Action {
  readonly type = ORDERDETAIL_CREATE_START_EDIT_MATERIAL;

  constructor(readonly payload: Material) {}
}

export class OrderDetailCreateSaveMaterialStartAction implements Action {
  readonly type = ORDERDETAIL_CREATE_SAVE_MATERIAL_START;

  constructor(readonly payload: { material: any; preventRestCall: boolean; showPopup: boolean }) {}
}

export class OrderDetailCreateSaveMaterialOverloadAction implements Action {
  readonly type = ORDERDETAIL_CREATE_SAVE_MATERIAL_OVERLOAD;
  logPayload = true;

  constructor(readonly payload: { calculation: CalculatedTruckLoad; material: Material }) {}
}

export class OrderDetailCreateSaveMaterialSuccessAction implements Action {
  readonly type = ORDERDETAIL_CREATE_SAVE_MATERIAL_SUCCESS;

  constructor(readonly payload: { calculation: CalculatedTruckLoad; material: Material, restrictions: ContractRestrictions }) {}
}

export class OrderDetailCreateSaveMaterialFailAction implements Action {
  readonly type = ORDERDETAIL_CREATE_SAVE_MATERIAL_FAIL;
  logPayload = true;

  constructor(readonly payload: { error: any; material: Material }) {}
}

export class OrderDetailLoadTruckCalculateAction implements Action {
  ui = {
    id: ORDERDETAIL_LOAD_TRUCK_CALCULATE,
    busy: true,
  };

  readonly type = ORDERDETAIL_LOAD_TRUCK_CALCULATE;
}

export class OrderDetailLoadTruckCalculateSuccessAction implements Action {
  readonly type = ORDERDETAIL_LOAD_TRUCK_CALCULATE_SUCCESS;
  logPayload = true;

  ui = {
    id: ORDERDETAIL_LOAD_TRUCK_CALCULATE,
    busy: false,
  };

  constructor(readonly payload: CalculatedTruckLoad) {}
}

export class OrderDetailLoadTruckCalculateFailAction implements Action {
  readonly type = ORDERDETAIL_LOAD_TRUCK_CALCULATE_FAIL;
  logPayload = true;

  ui = {
    id: ORDERDETAIL_LOAD_TRUCK_CALCULATE,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class OrderDetailCreateRemoveMaterialAction implements Action {
  readonly type = ORDERDETAIL_CREATE_DELETE_MATERIAL;

  constructor(readonly payload: any) {}
}

export class OrderDetailEditCustomerAction implements Action {
  readonly type = ORDERDETAIL_EDIT_CUSTOMER;
}

export class OrderDetailEditDeliveryMethodAction implements Action {
  readonly type = ORDERDETAIL_EDIT_DELIVERY_METHOD;
}

export class OrderDetailSaveOrderDetailAction implements Action {
  readonly type = ORDERDETAIL_CREATE_SAVE_ORDER_DETAIL;
  logPayload = true;

  constructor(readonly payload: { preventGetDeliveryDatesCall?: boolean }) {}
}

export class OrderDetailSaveOrderDetailGetDatesSuccessAction implements Action {
  readonly type = ORDERDETAIL_CREATE_SAVE_ORDER_DETAIL_GET_DATES_SUCCESS;
}

export class OrderDetailSavePlanningAction implements Action {
  readonly type = ORDERDETAIL_CREATE_SAVE_PLANNING;

  constructor(readonly payload: any) {}
}

export class OrderDetailCreateSubmitAction implements Action {
  readonly type = ORDERDETAIL_CREATE_SUBMIT;

  constructor(readonly payload: { emailAddresses: SimplifiedEmailActor[]; loadingDates: string[] }) {}
}

export class OrderDetailCreateSubmitFailAction implements Action {
  readonly type = ORDERDETAIL_CREATE_SUBMIT_FAIL;
  logPayload = true;

  constructor(readonly payload?: any) {}
}

export class OrderDetailCreateSubmitSuccessAction implements Action {
  readonly type = ORDERDETAIL_CREATE_SUBMIT_SUCCESS;

  constructor(readonly payload?: any) {}
}

export class OrderDetailGoBackToDeliveryAction implements Action {
  readonly type = ORDERDETAIL_BACK_TO_DELIVERY;

  constructor(readonly payload: string) {
    // payload = module (flow or order)
  }
}

export class OrderDetailGoBackToDetailAction implements Action {
  readonly type = ORDERDETAIL_BACK_TO_DETAIL;

  constructor(readonly payload: string) {
    // payload = module (flow or order)
  }
}

export class OrderDetailRequestDeliveryDatesAction implements Action {
  readonly type = ORDERDETAIL_REQUEST_DELIVERY_DATES;

  ui = {
    id: ORDERDETAIL_REQUEST_DELIVERY_DATES,
    busy: true,
  };

  constructor(readonly payload?: Actions) {} // Which action to trigger when success
}

export class OrderDetailRequestDeliveryDatesSuccessAction implements Action {
  readonly type = ORDERDETAIL_REQUEST_DELIVERY_DATES_SUCCESS;

  ui = {
    id: ORDERDETAIL_REQUEST_DELIVERY_DATES,
    busy: false,
  };

  constructor(readonly payload: AvailablePickingDates) {}
}

export class OrderDetailRequestDeliveryDatesFailAction implements Action {
  readonly type = ORDERDETAIL_REQUEST_DELIVERY_DATES_FAIL;
  logPayload = true;

  ui = {
    id: ORDERDETAIL_REQUEST_DELIVERY_DATES,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class NEOrderDetailRequestDeliveryDatesAction implements Action {
  readonly type = ORDERDETAIL_REQUEST_DELIVERY_DATES_NOEFFECT;

  ui = {
    id: ORDERDETAIL_REQUEST_DELIVERY_DATES_NOEFFECT,
    busy: true,
  };

  constructor(readonly payload?: Actions) {}
}

export class NEOrderDetailRequestDeliveryDatesSuccessAction implements Action {
  readonly type = ORDERDETAIL_REQUEST_DELIVERY_DATES_SUCCESS_NOEFFECT;

  ui = {
    id: ORDERDETAIL_REQUEST_DELIVERY_DATES_NOEFFECT,
    busy: false,
  };

  constructor(readonly payload: AvailablePickingDates) {}
}

export class NEOrderDetailRequestDeliveryDatesFailAction implements Action {
  readonly type = ORDERDETAIL_REQUEST_DELIVERY_DATES_FAIL_NOEFFECT;
  logPayload = true;

  ui = {
    id: ORDERDETAIL_REQUEST_DELIVERY_DATES_NOEFFECT,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class OrderDetailCopyOrderAction implements Action {
  readonly type = ORDERDETAIL_COPY_ORDER;
  logPayload = true;

  constructor(readonly payload: { etmOrderNumber: string }) {} // id
}

export class OrderDetailCopyOpenSuccessAction implements Action {
  readonly type = ORDERDETAIL_COPY_OPEN_ORDER_SUCCESS;

  constructor(readonly payload: { definitions: Definitions; orderDetail: OrderDetailTO }) {}
}

export class OrderDetailCopyOpenNoValidContractAction implements Action {
  readonly type = ORDERDETAIL_COPY_OPEN_ORDER_NO_VALID_CONTRACT;
}

export class OrderDetailCreateFromTemplateAction implements Action {
  readonly type = ORDERDETAIL_CREATE_FROM_TEMPLATE;

  constructor(readonly payload: { template: { data: OrderDetailTO; id: number; name: string }; date?: string; customer: Customer; definitions: Definitions }) {}
}

export class OrderDetailResetMaterialsAndPlanningAction implements Action {
  readonly type = ORDERDETAIL_RESET_MATERIALS_AND_PLANNING;
}

export class OrderDetailDocumentDownloadAction implements Action {
  readonly type = ORDERDETAIL_DOCUMENT_DOWNLOAD;
  logPayload = true;

  constructor(readonly payload: { documentId: string; extension: string }) {}
}

export class OrderDetailDocumentDownloadSuccessAction implements Action {
  readonly type = ORDERDETAIL_DOCUMENT_DOWNLOAD_SUCCESS;

  constructor(readonly payload: { blob: Blob; filename: string }) {}
}

export class OrderDetailDocumentDownloadFailAction implements Action {
  readonly type = ORDERDETAIL_DOCUMENT_DOWNLOAD_FAIL;
  logPayload = true;

  constructor(readonly payload: any) {}
}

export class OrderDetailCCRDocumentAction implements Action {
  readonly type = ORDERDETAIL_CCR_DOCUMENT_DOWNLOAD;
  logPayload = true;

  constructor(readonly payload: { documentId: string; extension: string }) {}
}

export class OrderDetailCCRDocumentSuccessAction implements Action {
  readonly type = ORDERDETAIL_CCR_DOCUMENT_DOWNLOAD_SUCCESS;

  constructor(readonly payload: { blob: Blob; filename: string }) {}
}

export class OrderDetailCCRDocumentFailAction implements Action {
  readonly type = ORDERDETAIL_CCR_DOCUMENT_DOWNLOAD_FAIL;
  logPayload = true;

  constructor(readonly payload: any) {}
}

export class OrderDetailGetRecurrenceDatesAction implements Action {
  readonly type = ORDERDETAIL_GET_RECURRENCE_DATES;

  constructor(readonly payload: any) {}
}

export class OrderDetailGetRecurrenceDatesSuccessAction implements Action {
  readonly type = ORDERDETAIL_GET_RECURRENCE_DATES_SUCCESS;
  logPayload = true;

  constructor(readonly payload: RecurrenceDates) {}
}

export class OrderDetailGetRecurrenceDatesFailAction implements Action {
  readonly type = ORDERDETAIL_GET_RECURRENCE_DATES_FAIL;
  logPayload = true;

  constructor(readonly payload: any) {}
}

export class OrderDetailBackToCreateConfirmAction implements Action {
  readonly type = ORDERDETAIL_BACK_TO_CREATE_CONFIRM;
}

export type Actions =
  | OrderDetailCreateStartAction
  | OrderDetailCreateSetCustomerAction
  | OrderDetailCreateSetDeliveryMethodAction
  | OrderDetailEditCustomerAction
  | OrderDetailEditDeliveryMethodAction
  | OrderDetailCreateEditOrderDetailAction
  | OrderDetailCreateStartEditMaterialAction
  | OrderDetailCreateSaveMaterialStartAction
  | OrderDetailCreateSaveMaterialSuccessAction
  | OrderDetailCreateSaveMaterialFailAction
  | OrderDetailLoadTruckCalculateAction
  | OrderDetailCreateSaveMaterialOverloadAction
  | OrderDetailLoadTruckCalculateSuccessAction
  | OrderDetailLoadTruckCalculateFailAction
  | OrderDetailCreateRemoveMaterialAction
  | OrderDetailSaveOrderDetailAction
  | OrderDetailSaveOrderDetailGetDatesSuccessAction
  | OrderDetailSavePlanningAction
  | OrderDetailCreateSubmitAction
  | OrderDetailCreateSubmitFailAction
  | OrderDetailCreateSubmitSuccessAction
  | OrderDetailClearAction
  | OrderDetailOpenAction
  | OrderDetailOpenFailAction
  | OrderDetailOpenSuccessAction
  | OrderDetailRequestDeliveryDatesAction
  | OrderDetailRequestDeliveryDatesSuccessAction
  | OrderDetailRequestDeliveryDatesFailAction
  | NEOrderDetailRequestDeliveryDatesAction
  | NEOrderDetailRequestDeliveryDatesSuccessAction
  | NEOrderDetailRequestDeliveryDatesFailAction
  | OrderDetailCreateEditOrderPlanningAction
  | OrderDetailCreateEditOrderPlanningGetDatesSuccessAction
  | OrderCreateGetLoadingDatesAction
  | OrderDetailGoBackToDeliveryAction
  | OrderDetailGoBackToDetailAction
  | OrderDetailCopyOrderAction
  | OrderDetailCopyOpenSuccessAction
  | OrderDetailCopyOpenNoValidContractAction
  | OrderDetailCreateFromTemplateAction
  | OrderDetailDocumentDownloadAction
  | OrderDetailDocumentDownloadSuccessAction
  | OrderDetailDocumentDownloadFailAction
  | OrderDetailCCRDocumentAction
  | OrderDetailCCRDocumentSuccessAction
  | OrderDetailCCRDocumentFailAction
  | OrderDetailGetRecurrenceDatesAction
  | OrderDetailGetRecurrenceDatesSuccessAction
  | OrderDetailGetRecurrenceDatesFailAction
  | OrderDetailBackToCreateConfirmAction
  | OrderDetailResetMaterialsAndPlanningAction
  | OrderDetailBackToOverviewAction
  | OrderDetailSetActiveCustomerAction;
